module.exports = __webpack_public_path__ + "img/10_101.97a9a9b1.png";